import { defineComponent as _defineComponent } from 'vue'
import GeoJsonSource from '../mapbox/GeoJsonSource.vue'
import LayerGroup from '../mapbox/LayerGroup.vue'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import mapboxgl from 'mapbox-gl'
import { resourcePinStyle } from './styles/resource-pin'
import { useJobFilterStore } from '@/components/field-view-next/JobsFilterStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcesLayer',
  props: {
    layerId: null,
    sourceId: null,
    hiddenFeatureIds: null,
    before: null,
    hideLayer: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (
    event: 'click',
    data: mapboxgl.MapboxGeoJSONFeature[],
    eventData: mapboxgl.MapMouseEvent & mapboxgl.EventData
  )
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  layerId: string
  sourceId: string
  hiddenFeatureIds?: (number | string)[]
  before?: string
  hideLayer?: boolean
}





const jobsFilterStore = useJobFilterStore()
jobsFilterStore.$subscribe(() => {
  refreshLayer()
})

const handleClick = (
  data: mapboxgl.MapboxGeoJSONFeature[],
  eventData: mapboxgl.MapMouseEvent & mapboxgl.EventData
) => {
  emits('click', data, eventData)
}

const layers: mapboxgl.SymbolLayer[] = [
  {
    id: props.layerId,
    type: 'symbol',
    layout: {
      ...resourcePinStyle.layout,
    },
    paint: {
      ...resourcePinStyle.paint,
    },
  },
]

const source = ref()
const refreshLayer = () => {
  if (source.value && typeof source.value.refreshData === 'function') {
    source.value.refreshData()
  }
}

const pollingInterval = ref()
const resourcePolling = () => {
  refreshLayer()
  pollingInterval.value = setTimeout(resourcePolling, 30000)
}

const handleVisibilityChange = () => {
  if (document.hidden) {
    clearTimeout(pollingInterval.value)
  } else {
    resourcePolling()
  }
}

onMounted(() => {
  resourcePolling()
  document.addEventListener('visibilitychange', handleVisibilityChange)
})

onBeforeUnmount(() => {
  clearTimeout(pollingInterval.value)
  pollingInterval.value = null
  document.removeEventListener('visibilitychange', handleVisibilityChange)
})

const filter = computed(() => {
  const filter: any[] = ['all']
  const ids = props.hiddenFeatureIds || []
  if (ids.length > 0) {
    filter.push(['!', ['in', ['id'], ['literal', ids]]])
  }

  if (jobsFilterStore.selectedResourceTypes.length > 0) {
    filter.push([
      'in',
      ['get', 'ResourceTypeId'],
      ['literal', jobsFilterStore.selectedResourceTypes],
    ])
  }

  if (jobsFilterStore.selectedServiceProviders.length > 0) {
    filter.push([
      'in',
      ['get', 'OwnerId'],
      ['literal', jobsFilterStore.selectedServiceProviders],
    ])
  }

  if (jobsFilterStore.selectedDivisions.length > 0) {
    filter.push([
      'in',
      ['get', 'DivisionId'],
      ['literal', [null, ...jobsFilterStore.selectedDivisions]],
    ])
  }

  return filter
})

const url = computed(() => {
  return `${window.location.origin}/api/v3/field-view/geojson/resources`
})

return { __sfc: true,props, emits, jobsFilterStore, handleClick, layers, source, refreshLayer, pollingInterval, resourcePolling, handleVisibilityChange, filter, url, GeoJsonSource, LayerGroup }
}

})